import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminSchools from "@/pages/admin/AdminSchools";
import AdminChangePassword from "@/pages/admin/AdminChangePassword";
import Storefront from "@/pages/student/Storefront";
import MyBooks from "@/pages/student/MyBooks";
import Reservations from "@/pages/student/Reservations";
import Wallet from "@/pages/student/Wallet";
import Subscription from "@/pages/student/Subscription";

function AppShell({ children }) {
    return (
        <div className="min-h-screen bg-paper">
            <Navbar />
            {children}
        </div>
    );
}

function RootRedirect() {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (!user) return <Landing />;
    return <Navigate to={user.role === "admin" ? "/admin" : "/app/storefront"} replace />;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-center" richColors closeButton toastOptions={{ duration: 4500 }} />
                <Routes>
                    <Route path="/" element={<RootRedirect />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />

                    <Route path="/admin" element={
                        <ProtectedRoute role="admin"><AppShell><AdminSchools /></AppShell></ProtectedRoute>
                    } />
                    <Route path="/admin/password" element={
                        <ProtectedRoute role="admin"><AppShell><AdminChangePassword /></AppShell></ProtectedRoute>
                    } />

                    <Route path="/app/storefront" element={
                        <ProtectedRoute role="student"><AppShell><Storefront /></AppShell></ProtectedRoute>
                    } />
                    <Route path="/app/my-books" element={
                        <ProtectedRoute role="student"><AppShell><MyBooks /></AppShell></ProtectedRoute>
                    } />
                    <Route path="/app/reservations" element={
                        <ProtectedRoute role="student"><AppShell><Reservations /></AppShell></ProtectedRoute>
                    } />
                    <Route path="/app/wallet" element={
                        <ProtectedRoute role="student"><AppShell><Wallet /></AppShell></ProtectedRoute>
                    } />
                    <Route path="/app/subscription" element={
                        <ProtectedRoute role="student"><AppShell><Subscription /></AppShell></ProtectedRoute>
                    } />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
